import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Mail',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1.18 14.12c.21.18.24.49.06.7a.49.49 0 0 1-.7.06l-5.69-4.74-1.84 1.61c-.18.17-.41.25-.65.25s-.47-.08-.66-.25L9.5 13.14l-5.69 4.74a.478.478 0 0 1-.69-.06.493.493 0 0 1 .06-.7l5.56-4.64-5.4-4.73c-.42-.36-.46-1-.09-1.41.36-.42 1-.46 1.41-.09L12 12.67l7.34-6.42c.41-.36 1.05-.32 1.41.09.36.42.32 1.05-.09 1.41l-5.4 4.73 5.56 4.64z" }
      })]
    );
  }
};